import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import { ExperimentIcon } from '@spotify/confidence-core-react';
import { createWorkflowExtension } from '@spotify/plugin-confidence-workflows';

import { ReanalysisTableRow } from './components';
import { REANALYSIS_WORKFLOW_ID } from './constants';

export const confidenceWorkflowsModuleReanalysisPlugin = createPlugin({
  id: 'confidence-workflows-module-reanalysis',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-analysis-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const ReanalysisWorkflowPage = loadable(
  () => componentsChunk().then(m => m.ReanalysisWorkflowPage),
  loadOptions,
);
const ReanalysisWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.ReanalysisWorkflowInstancePage),
  loadOptions,
);
const CreateReanalysis = loadable(
  () => componentsChunk().then(m => m.CreateReanalysis),
  loadOptions,
);

export const ReanalysisWorkflowExtension =
  confidenceWorkflowsModuleReanalysisPlugin.provide(
    createWorkflowExtension({
      title: 'Analysis',
      workflowId: REANALYSIS_WORKFLOW_ID,
      workflowPage: () => <ReanalysisWorkflowPage />,
      workflowInstancePage: () => <ReanalysisWorkflowInstancePage />,
      workflowTableRowComponent: ReanalysisTableRow,
      workflowIcon: ExperimentIcon,
      createComponent: () => <CreateReanalysis />,
    }),
  );
